import { useWebsiteSettings } from 'client/store'
import React from 'react'
import { useThemeColor } from 'src/editor/shared/hooks/use-theme-color'
import { useUpdateStoreObjectProp } from 'src/editor/shared/hooks/use-update-store'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { WebsiteButtonGroup } from 'src/editor/shared/settings/wrappers/website-button-group'
import {
  updateWebsiteStylesPrimaryButtons,
  updateWebsiteStylesSecondaryButtons,
  updateWebsiteThemeLinks,
} from 'src/editor/store/website-settings/website-settings-actions'
import {
  getWebsiteDraftTheme,
  getWebsiteStylesPrimaryButtons,
  getWebsiteStylesSecondaryButtons,
} from 'src/editor/store/website-settings/website-settings-selector'
import {
  WebsiteButtonsInterface,
  WebsiteSettingsTypographyTypeEnum,
  WebsiteThemeLinksInterface,
} from 'src/shared/types/website-settings-types'
import { GroupTitle } from '../settings/group-title'
import { primaryButtonColorsKeys, secondaryButtonColorsKeys } from './consts'

export const WebsiteStylesSettingsButtonsAndLinks = () => {
  const primaryButtons = useWebsiteSettings(getWebsiteStylesPrimaryButtons)
  const linksColor = useWebsiteSettings(getWebsiteDraftTheme)?.links
  const secondaryButtons = useWebsiteSettings(getWebsiteStylesSecondaryButtons)
  const updatePrimaryButtonProp = useUpdateStoreObjectProp(
    primaryButtons as WebsiteButtonsInterface,
    updateWebsiteStylesPrimaryButtons,
  )

  const updateSecondaryButtonProp = useUpdateStoreObjectProp(
    secondaryButtons as WebsiteButtonsInterface,
    updateWebsiteStylesSecondaryButtons,
  )
  const updateWebsiteThemeLinksProp = useUpdateStoreObjectProp(
    linksColor as WebsiteThemeLinksInterface,
    updateWebsiteThemeLinks,
  )

  const { links } = useThemeColor()

  return (
    <>
      <WebsiteButtonGroup
        withoutHorizontalLine
        label={'website_styles_settings.buttons_and_links.primary.title'}
        buttonType={WebsiteSettingsTypographyTypeEnum.PrimaryButton}
        updateWebsiteStylesButtons={updatePrimaryButtonProp}
        colorKeys={primaryButtonColorsKeys}
      />

      <WebsiteButtonGroup
        label={'website_styles_settings.buttons_and_links.secondary.title'}
        buttonType={WebsiteSettingsTypographyTypeEnum.SecondaryButton}
        updateWebsiteStylesButtons={updateSecondaryButtonProp}
        colorKeys={secondaryButtonColorsKeys}
      />

      <GroupTitle>
        website_styles_settings.buttons_and_links.link.title
      </GroupTitle>
      <ColorPickerControl
        update={updateWebsiteThemeLinksProp('linkTextColor')}
        color={links.linkTextColor}
        label="website_theme_settings.group.link.text_color"
        singleColorMode
        isClearable
      />
      <ColorPickerControl
        update={updateWebsiteThemeLinksProp('linkHoveredBackgroundColor')}
        color={links.linkHoveredBackgroundColor}
        label="website_theme_settings.group.link.hovered_button_background_color"
        singleColorMode
        isClearable
      />
      <ColorPickerControl
        update={updateWebsiteThemeLinksProp('linkPressedBackgroundColor')}
        color={links.linkPressedBackgroundColor}
        label="website_theme_settings.group.link.pressed_button_background_color"
        singleColorMode
        isClearable
      />
    </>
  )
}
